import { KeyValueModel } from "./key-value-model";

export class Constants {

  static GetDayOfWeek(date) {
    var dayOfWeek = new Date(date).getDay();
    return isNaN(dayOfWeek)
      ? null
      : [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ][dayOfWeek];
  }
  /**
 *  Default Static message if there is no record in grid
 */
  static defaultNoRowGridMessge: string = 'No records available.';
  static defaultNoRowDropdownMessge: string = 'No data found';
  /**
  *  Default Static timeout for spinner for whole application
  */
  static defaultSpinnertimeout: number = 400;
  /**
  * Static pages which do not open dynamically and needs tabcounter for showloader
  */
  static get FixedtabCounters() {
    return {
      loginComponent: 99999,
      appComponent: 99998
    }
  }
  static get DefaultImagePaths() {
    return {
      Labour: "./assets/images/default/Labor.svg",
      Service: "./assets/images/default/Service.svg",
      Material: "./assets/images/default/Material.svg",
      Category: "./assets/images/default/Category.svg",
      WorkOrderEquipmentLink: "./assets/images/default/WorkOrderEquipmentLink.svg",
      ImageLogo: "./assets/images/default/Image-Logo.png",
      ServiceAgreementItem: "./assets/images/default/ServiceAgreementItem.svg"
    };
  }
  static get DefaultWorkOrderMessages() {
    // component reference - work-order-review-detail, app-work-order-list
    return {
      WorkOrderDispatchedWithWOMessage: function (WorkOrder, primaryTech) {
        return `Work Order ${WorkOrder} dispatched to ${primaryTech}.`;
      },
      WorkOrderDispatchedMessage:
        "Work Order has been dispatched successfully.",
      WorkOrderVoidedMessage: "Work Order has been voided successfully.",
      WorkOrderAssignedMessage: "Work Order has been assigned successfully.",
      WorkOrderUnAssignedMessage:
        "Work Order has been unassigned successfully.",
      WorkOrderResheduledMessage:
        "Work Order has been changed to be rescheduled successfully.",
      WorkOrderCancelledMessage: "Work Order has been cancelled successfully.",
      WorkOrderCompletedMessage: "Work Order has been completed successfully.",
      WorkOrderRecalledMessage: "Work Order has been successfully recalled.",
      WorkOrderRecalledandUnAssignedMessage:
        "Work Order has been successfully recalled and unassigned.",
      WorkOrderOpenMessage: "Work Order state changed to Open.",
      WorkOrderOpenandTechnicianMessage:
        "Work Order state changed to Open and technician removed.",
      WorkOrderPostedWithoutIntegrationMessage:
        "Work Order Posted successfully.",

      HelperDispatchedMessage: "Appointment has been dispatched successfully.",
      HelperUndoDispatchedMessage : "Appointment has been successfully recalled.",
      HelperAssignedMessage: "Appointment has been assigned successfully."
    };
  }
  static monthsList = [
    { Name: "January", Value: "01" },
    { Name: "February", Value: "02" },
    { Name: "March", Value: "03" },
    { Name: "April", Value: "04" },
    { Name: "May", Value: "05" },
    { Name: "June", Value: "06" },
    { Name: "July", Value: "07" },
    { Name: "August", Value: "08" },
    { Name: "September", Value: "09" },
    { Name: "October", Value: "10" },
    { Name: "November", Value: "11" },
    { Name: "December", Value: "12" }
  ];
  static Pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
  /** This property is used to set default file size for kendo and html file upload control */
  static get DefaultFileExtension(): string[] {
    return [
      ".bmp", ".gif", ".jpeg", ".jpg",
      ".tex", ".xls", ".xlsx", ".doc",
      ".docx", ".odt", ".txt", ".pdf",
      ".png", ".pptx", ".ppt", ".rtf"
    ];
  }
  /** This property is used to set default image extension for kendo and html file upload control */
  static get DefaultImageExtension(): string[] {
    return [
      ".jpg", ".jpeg", ".gif",
      ".png", ".bmp"
    ]
  }
  /** This property is used to set default file size for kendo and html file upload control */
  static get DefaultFileSize() {
    return {
      inMegabytes: 4,
      inbytes: 4194304
    };
  }
  static WOStaticStatus() {
    return {
      Assign: "Assign",
      Cancel: "Cancel",
      CancelWorkOrder: "Cancel Work Order",
      Complete: "Complete",
      CompleteWorkOrder: "Complete Work Order",
      ContinuewithWorkOrder: "Continue with Work Order",
      Dispatch: "Dispatch",
      DispatchWorkOrder: "Dispatch Work Order",
      PostWorkOrder: "Post Work Order",
      RemoveTechnician: "Remove Technician",
      Reschedule: "Reschedule",
      RescheduleWorkOrder: "Reschedule Work Order",
      SameTechnician: "Same Technician",
      Unassign: "Unassign",
      UnassignWorkOrder: "Unassign Work Order",
      UndoDispatching: "Undo Dispatching",
      Void: "Void",
      VoidWorkOrder: "Void Work Order",
      actionrequired: "actionrequired",
      approved: "approved",
      assign: "assign",
      assigned: "assigned",
      cancelled: "cancelled",
      completeWithWarning: "Complete with Warning",
      completed: "completed",
      dispatch: "dispatch",
      dispatched: "dispatched",
      open: "open",
      partsneeded: "partsneeded",
      posted: "posted",
      postingfailure: 'postingfailure',
      readyforreview: "readyforreview",
      reschedule: "reschedule",
      rescheduled: "rescheduled",
      techreceived: "techreceived",
      unassigned: "unassigned",
      void: "void",
      voided: "voided",
      working: "working",
      Continue: "continue"
    }
  }
  static CustomToastMessages() {
    return {
      EquipmentCreateSuccess: "Equipment saved successfully",
      EquipmentUpdateSuccess: "Equipment updated successfully",
      EquipmentDeleteSuccess: "Equipment deleted successfully",
      EquipmentInactive: "Equipment has been used so cannot be deleted. Record was made inactive.",
      CompanyUpdateSuccess:"Company updated successfully"
    }
  }
  static CustomToastMessages_Waranty(formObjName) {
    return {
      EquipWarrUpdateSuccess: "Equipment Warranty " + formObjName + " updated",
      EquipWarrCreateSuccess: "Equipment Warranty " + formObjName + " created",
      EquipWarrDeleteSuccess: "Equipment Warranty " + formObjName + " deleted",
      EquipWarrInactive: "The record " + formObjName + " has been used so cannot be deleted. Record was made inactive."
    }
  }
  static CustomToastMessages_ComCode(Name, type) {
    return {
      ComCodeCreateSuccess: type + Name + " created",
      ComCodeUpdateSuccess: type + Name + " updated",
      ComCodeInactiveSuccess: "The record " + Name + " has been used so cannot be deleted. Record was made inactive",
      ComCodeDeleteSuccess: type + Name + " deleted"
    }
  }
  static get ItemType() {
    return {
      Labor: "LaborItem",
      Service: "ServiceItem",
      Material: "MaterialItem",
      Agreement: "AgreementItem"
    };
  }
  static RequestType_PUT = "PUT";
  static RequestType_POST = "POST";
  static DATETIME_MIN = "0001-01-01T00:00:00";
  static Operators : KeyValueModel[] = [
    { Key: "c", Value: "contains" },
    { Key: "dnc", Value: "not_contains" },
    { Key: "b", Value: "is_empty" },
    { Key: "nb", Value: "is_not_empty" },
    { Key: "in", Value: "in" },
    { Key: "nin",  Value: "not_in" },
    { Key: "eq",  Value: "equal" },
    { Key: "lte",  Value: "less_or_equal" },
    { Key: "lt",  Value: "less" },
    { Key: "startswith",  Value: "begins_with" },
    { Key: "endswith",  Value: "ends_with" },
    { Key: "contains",  Value: "contains" },
    { Key: "doesnotcontain",  Value: "not_contains" },
    { Key: "gt",  Value: "greater" },
    { Key: "gte",  Value: "greater_or_equal" },
    { Key: "neq",  Value: "not_equal" },
    { Key: "null",  Value: "is_null" },
    { Key: "notnull",  Value: "is_not_null" }];
  static PhoneMask = "(000) 000-0000";
  static UrlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  static get GridActions() {
    return {
      Edit: "Edit",
      Duplicate: "Duplicate",
      Delete: "Delete",
      JobSiteEquipment: {
        ViewDetails: "View Details",
        ViewHistory: "View History"
      }
    };
  }
  static EntityName() {
    return {
      Customer: "customer",
      JobSite: "jobsite",
      Invoice: "invoice",
      Payment: "payment"
    };
  }
  static DispatcherMessages() {
    return {
      /** Events cannot be scheduled for more than 1 calender day. */
      Validation_OneCalendarDay: "Events cannot be scheduled for more than 1 calender day.",
      /** Events cannot be scheduled for <br> more than 1 calender day. */
      Validation_OneCalendarDay_With_BRTag: "Events cannot be scheduled for <br> more than 1 calender day.",
      /** Event cannot be scheduled within this time range as its overlapping with other events. */
      Validation_OverlappingEvents: "Event cannot be scheduled within this time range as its overlapping with other events.",
      /** Promised Time mismatch for Work Order and Time Slot. Do you want to proceed ? */
      Validation_PromiseTimeMismatch: "Promised Time mismatch for Work Order and Time Slot. Do you want to proceed ?",
      /** Department mismatch for Work Order and Technician. Do you want to proceed ? */
      Validation_DepartmentMismatchForWOAndTech: "Department mismatch for Work Order and Technician. Do you want to proceed ?",
      /** Promise Date mismatch for Work Order and Technician. Do you want to proceed ? */
      Validation_PromiseDateMismatchForWOAndTech: "Promise Date mismatch for Work Order and Technician. Do you want to proceed ?",
      /** Promise Date/ Department mismatch for Work Order and Technician. Do you want to proceed ? */
      Validation_PromiseDateDeptMismatchForWOAndTech: "Promise Date/ Department mismatch for Work Order and Technician. Do you want to proceed ?",
      /** Promise Date/ Promise Time mismatch for Work Order and Technician. Do you want to proceed ? */
      Validation_PromiseDateTimeMismatchForWOAndTech: "Promise Date/ Promise Time mismatch for Work Order and Technician. Do you want to proceed ?",
      /** Promise Time/ Department mismatch for Work Order and Technician. Do you want to proceed ? */
      Validation_PromiseTimeDeptMismatchForWOAndTech: "Promise Time/ Department mismatch for Work Order and Technician. Do you want to proceed ?",
      /** Department, Promise Date and Promised Time mismatch for Work Order and Technician/ Time Slot. Do you want to proceed ? */
      Validation_PromiseDateTimeDeptMismatchForWOAndTech: "Department, Promise Date and Promised Time mismatch for Work Order and Technician/ Time Slot. Do you want to proceed ?",
      /** Work Order cannot be scheduled within this time range. */
      Validation_WorkOrderTimeRange: "Work Order cannot be scheduled within this time range."
    }
  }
  static CustomToastMessages_Dispatcher(value = "") {
    return {
      /** Appointment deleted successfully. */
      AppointmentDeleteSuccess: "Appointment deleted successfully.",
      /** Appointment has been saved successfully. */
      AppointmentSaveSuccess: "Appointment has been saved successfully.",
      /** Appointment unassigned successfully. */
      AppointmentUnassignSuccess: "Appointment unassigned successfully.",
      /** Appointment has been updated successfully. */
      AppointmentUpdateSuccess: "Appointment has been updated successfully.",
      /** Work Order - " + value + " has been assigned successfully. */
      WOAssignSuccess: "Work Order - " + value + " has been assigned successfully.",
      /** Work Order - " + value + " has been dispatched successfully. */
      WODispatchSuccess: "Work Order - " + value + " has been dispatched successfully.",
      /** Work Order cannot be updated as it contains Invalid Data */
      WOInvalidData: "Work Order cannot be updated as it contains Invalid Data",
      /** "Work Order - " + value + " has been successfully recalled and unassigned. */
      WORecallAndUnassignSuccess: "Work Order - " + value + " has been successfully recalled and unassigned.",
      /** Work Order - " + value + " has been unassigned successfully. */
      WOUnassignSuccess: "Work Order - " + value + " has been unassigned successfully.",
      /** Work Order - " + value + " has been updated successfully. */
      WOUpdateSuccess: "Work Order - " + value + " has been updated successfully.",
    }
  }
  static SAStaticStatus() {
    return {
      Cancel: "Cancel",
      CancelServiceAgreement: "Cancel Service Agreement",
      Suspend: "Suspend",
      SuspendServiceAgreement: "Suspend Service Agreement",
      
    }
  }
  static pageSizes = [25, 100, 300];
  static debounceInterval = 1000;
}
